// extracted by mini-css-extract-plugin
export default {"title":"Faq_title__D0Q+7","nav":"Faq_nav__M-7IY","btn":"Faq_btn__wAjJs","active":"Faq_active__aKJA-","dropdown":"Faq_dropdown__AC+K5","list":"Faq_list__typb6"};